import { Component, OnInit, Input } from '@angular/core';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { GetOperations } from 'app/shared/common/helper/dropdown';
import { ToastrService } from 'ngx-toastr';
import { DateConvertor } from 'app/shared/common/helper/dateConvertor';
import { ActivatedRoute } from '@angular/router';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { GetterSetter } from 'app/shared/common/helper/project';
import { ToastBaseModel } from 'app/shared/common/toast-data-model';

@Component({
  selector: 'app-activities',
  templateUrl: './activities.component.html',
  styleUrls: ['./activities.component.scss']
})

export class ActivitiesComponent implements OnInit {
  empRole = '';
  firstname: any;
  lastname: any;
  isEdit: boolean;
  objectId = '';
  // projectId: any;
  projectActivities = [];
  activities = [];
  projectValue: any;
  today = new Date();
  @Input() projectId: any;

  constructor(
    private route: ActivatedRoute,
    private queryInterface: QueryInterface,
    private parseService: ParseService,
    private projectInterface: GetterSetter,
    private dateConvertor: DateConvertor,
    private toastr: ToastrService,
    private toastMessage: ToastBaseModel,
    private profileDropDown: GetOperations,
    private storageConfiguration: StorageConfiguration) { }

  /*
  ** ==========================================================
  ** On Init
  ** ==========================================================
  */
  ngOnInit() {
    this.firstname = this.parseService.instance.User.current().get('firstName');
    this.lastname = this.parseService.instance.User.current().get('lastName');
    this.empRole = this.storageConfiguration.sessionGetItem(
      this.storageConfiguration.role
    );
    this.isEdit = false;
    this.route.params.subscribe(params => {
      this.objectId = params['id'];
      if (this.objectId != '' && this.objectId != undefined) {
        this.isEdit = true;
        this.getActivities();
      }
    });
  }

  /*
  ** ==========================================================
  ** Get Project Activities
  ** ==========================================================
  */
  getActivities() {
    let condition = [];
    let type = '';
    if (this.empRole == 'Admin') {
      condition = [
        { condition: 'equalTo', field: 'objectId', value: this.objectId },
        { condition: 'include', value: 'client' }
      ];
      type = 'Project';
    } else {
      condition = [
        { condition: 'include', value: 'project' },
        { condition: 'include', value: 'project.client' },
        { condition: 'include', value: 'user' },
        {
          condition: 'equalTo', field: 'project', value: {
            __type: 'Pointer',
            className: 'Project',
            objectId: this.objectId
          }
        }];
      type = 'ProjectMembers';
    }
    this.queryInterface.executeQuery(this.parseService, type, condition).then(results => {
      const result = results[0];
      if (this.empRole == 'Admin') {
        this.projectValue = this.projectInterface.getProject(result);
        this.projectActivities = this.projectValue.activities;
        let activity = this.projectActivities
        this.activities = activity.slice(0, 50);

        // this.projectId = result.id;
      } else {
        this.projectValue = this.projectInterface.getProject(result.get('project'));
        this.projectActivities = this.projectValue.activities;
        let activity = this.projectActivities
        this.activities = activity.slice(0, 50);

        // this.projectId = result.get('project').id;
      }
    });
  }

  /*
  ** ==========================================================
  ** Filter
  ** ==========================================================
  */
  filterApply(from, to) {
    let fromDate = new Date(from);
    let toDate = to !== '' ? new Date(new Date(to).setHours(23, 59, 59)) : new Date(new Date().setHours(23, 59, 59));
    if (from == '') {
      this.projectActivities = this.projectValue.activities;
    } else {
      let filteredActivities = this.projectValue.activities.filter(x => new Date(x.createdDate) >= new Date(fromDate) && new Date(x.createdDate) <= new Date(toDate));
      this.projectActivities = filteredActivities;
      this.activities = (this.projectActivities).slice(0, 50);
    }
  }

  getMinDate(date) {
    return new Date(date);
  }

  clearFilter() {
    this.projectActivities = this.projectValue.activities;
    this.activities = (this.projectActivities).slice(0, 50);
  }

  nextPage(event) {
    let activity = this.projectActivities;
    let start = event.pageIndex * event.pageSize;
    this.activities = activity.slice(start, start + event.pageSize);
  }


}
